import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pointer-events-none absolute left-2 flex size-4 items-center justify-center rounded border shadow-xs transition-shadow" }

import { cn } from '@/lib/utils';
    import { Check } from 'lucide-vue-next';
    import {
        DropdownMenuCheckboxItem,
        type DropdownMenuCheckboxItemEmits,
        type DropdownMenuCheckboxItemProps,
        DropdownMenuItemIndicator,
        useForwardPropsEmits,
    } from 'reka-ui';
    import { computed, type HTMLAttributes } from 'vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DropdownMenuCheckboxItem',
  props: {
    modelValue: { type: [Boolean, String] },
    disabled: { type: Boolean },
    textValue: {},
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] },
    class: {}
  },
  emits: ["select", "update:modelValue"],
  setup(__props: any, { emit: __emit }) {

    const props = __props;
    const emits = __emit;

    const delegatedProps = computed(() => {
        const { class: _, ...delegated } = props;

        return delegated;
    });

    const forwarded = useForwardPropsEmits(delegatedProps, emits);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DropdownMenuCheckboxItem), _mergeProps({ "data-slot": "dropdown-menu-checkbox-item" }, _unref(forwarded), {
    class: 
            _unref(cn)(
                `focus:text-primary relative flex cursor-pointer items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-xs outline-hidden select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg]:pointer-events-none [&_svg]:shrink-0 [&_svg:not([class*='size-'])]:size-4`,
                '[&[data-state=checked]>span]:border-primary',
                props.class,
            )
        
  }), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _createVNode(_unref(DropdownMenuItemIndicator), { class: "bg-primary text-primary-foreground flex h-full w-full items-center justify-center" }, {
          default: _withCtx(() => [
            _createVNode(_unref(Check), { class: "size-3" })
          ]),
          _: 1
        })
      ]),
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 16, ["class"]))
}
}

})